module.exports = __webpack_public_path__ + "static/media/logo.3b9b5565.svg";